var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('img',{staticClass:"saveImage",attrs:{"src":_vm.src,"alt":"","mode":"widthFix"}}),_c('div',{staticClass:"tips"},[_vm._v("长按保存志愿者证书到手机相册")])]),_c('vue-canvas-poster',{attrs:{"painting":_vm.painting},on:{"success":_vm.success,"fail":_vm.fail}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }